<template>
  <div>
    <div class="top-bar">
      <span @click="goBack()">
        <i class="left"></i>
      </span>
      <span class="heading_new">Selected Employees</span>
    </div>
    <div class="main-container">
      <tl-search @change="filterData" />
      <div class="space"></div>
      <data-table
        :columns="columnNames"
        :tableData="empdata"
        :selectedRecord="selectedEmployeesList"
        :checkbox="true"
        :showinrow="false"
        :actionbtn="true"
        :search="search"
        @headerSelection="selectAll($event)"
        @selected="getSelectedRecords($event)"
      >
        <template v-slot:rowcontent="slotprops">
          <img
            class="sm-img"
            v-if="slotprops.value.column.key=='imgSrc'"
            :src="slotprops.value.record[slotprops.value.column.key]"
          />
          <p
            v-if="slotprops.value.column.key!='imgSrc'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
        </template>
      </data-table>
    </div>
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="goBack()" />
          <btn text="Save" type="primary" @click="saveSelectedItem()" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
export default {
  data(){
    return{
      search:"",
      selectedEmployeesList:[],
      emplList:[],
      selectedList:[],
      columnNames: [
        {
          label: "",
          key: "imgSrc"
        },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "first_name"
        },
        {
          label: "Department",
          key: "bu_name"
        },
        {
          label: "Email ID",
          key: "official_email_id"
        },
        {
          label: "Location",
          key: "location_name"
        }
      ],
      empdata: [],
      alreadySelected: []
    };
  },
  computed:{
    // ...mapState("globalapi/globalemployees", {
    //   emplList: state => state.entityWiseData
    // }),

  },
  activated(){
    this.empdata= this.$route.params.emplList;
    //console.log(this.empdata);
    
    this.selectedEmployeesList = [...this.$route.params.selectedEmpList];
    this.selectedList = this.selectedEmployeesList;
  },

  methods: {
    filterData() {},
    getSelectedRecords(list){
      this.selectedList=list;
    },
    selectAll(list){
      this.selectedList = list;
    },
    goBack(){
      this.$router.go(-1)
    },
    saveSelectedItem(){
     this.$router.push({
        name: "dashboardSubstepname",
        params:{ step_name: this.$route.params.step_name,
            sub_step: this.$route.params.sub_step,
            sub_step_name: 'reportModule',
            entity_index: this.$route.params.entity_index,
            selemplist:this.selectedList}
       });
      }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}
.heading_new {
  width: auto;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
.space {
  padding-top: 34px;
}
.footer-width {
  width: 90%;
}
</style>
